define([], function() {
    return {
        getCommonParams: function() {
            return {
                mouseWheelEnabled: false,
                //lock product rotation by one or two axis, see DVV documentation
                //currently rotation is enabled
                lockAxis: false,
                limitAxis: { x0: -45, x1: 45 },
                worldAxis: false
            };
        }
    };
});
